/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { ShadowBox } from './Privacy.style';
import PrivacyWrapper from './PrivacyContainer';
import { Helmet } from 'react-helmet';

export default function TermsAndCondition({
  isLoggedIn,
  hideBackArrow,
  isAuthPage,
}) {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | WafyNet - User Agreement</title>
        <meta
          name="description"
          content="Review WafyNet's terms and conditions, including usage policies, user rights, and responsibilities when using our platform."
        />
      </Helmet>
      <PrivacyWrapper
        isLoggedIn={isLoggedIn}
        hideBackArrow={hideBackArrow}
        isAuthPage={isAuthPage}
      >
        <ShadowBox isauthpage={isAuthPage}>
          <div style={{ fontSize: 15 }}>
            <h2>Terms &amp; Conditions</h2>
            <p>Last Updated: 2024-07-23</p>

            <h3>General Terms</h3>
            <p>
              By accessing and using <strong>WafyNet</strong>, you agree to be
              bound by these Terms &amp; Conditions. These terms apply to the
              entire website, mobile application, and all services provided by
              WafyNet.
            </p>
            <p>
              Under no circumstances shall WafyNet or its team be liable
              for any direct, indirect, incidental, or consequential damages
              (including, but not limited to, loss of data, profits, or business
              interruption) arising out of your use or inability to use the
              Service. We reserve the right to revise content, change prices, or
              update policies at any time without prior notice.
            </p>

            <h3>License</h3>
            <p>
              WafyNet grants you a revocable, non-exclusive, non-transferable,
              limited license to access and use the website and mobile app
              strictly in accordance with these Terms &amp; Conditions.
            </p>

            <h3>Definitions</h3>
            <ul>
              <li>
                <strong>Company:</strong> WafyNet, Chennai, TamilNadu,
                India.
              </li>
              <li>
                <strong>Service:</strong> The website, mobile app, and related
                services provided by WafyNet.
              </li>
              <li>
                <strong>Customer:</strong> Any individual or entity using
                WafyNet Services.
              </li>
              <li>
                <strong>Device:</strong> Any internet-connected device used to
                access WafyNet.
              </li>
              <li>
                <strong>Personal Data:</strong> Any information that can
                identify a natural person.
              </li>
              <li>
                <strong>Third-Party Service:</strong> Advertisers, partners, or
                service providers integrated with WafyNet.
              </li>
              <li>
                <strong>Website:</strong>{' '}
                <a
                  href="https://www.wafynet.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.wafynet.com
                </a>
                .
              </li>
              <li>
                <strong>You:</strong> The individual or entity using the
                Service.
              </li>
            </ul>

            <h3>Restrictions</h3>
            <p>You agree not to:</p>
            <ul>
              <li>License, sell, rent, or commercially exploit the Service.</li>
              <li>
                Modify, reverse engineer, or create derivative works from the
                Service.
              </li>
              <li>
                Remove or alter any copyright, trademark, or proprietary
                notices.
              </li>
            </ul>

            <h3>Payment</h3>
            <p>
              If you register for paid services, you agree to pay all applicable
              fees as described at the time of purchase. Payments must be made
              using a valid payment method (e.g., Visa, MasterCard). You are
              responsible for updating billing details promptly. WafyNet
              reserves the right to modify pricing and billing methods with
              prior notice.
            </p>

            <h3>Refund Policy</h3>
            <p>
              If you are not satisfied with our products or services, please
              contact us at
              <a href="mailto:support@wafynet.com"> support@wafynet.com</a>.
              Refunds will be handled on a case-by-case basis in accordance with
              applicable consumer protection laws.
            </p>

            <h3>User Feedback</h3>
            <p>
              Any feedback, suggestions, or ideas you provide shall remain the
              property of WafyNet. We may use such submissions without
              obligation or compensation to you.
            </p>

            <h3>Third-Party Links</h3>
            <p>
              Our Service may contain links to third-party websites. We are not
              responsible for their content, terms, or practices. Use of
              third-party services is at your own risk.
            </p>

            <h3>Cookies</h3>
            <p>
              WafyNet uses cookies to enhance user experience and functionality.
              You may disable cookies in your browser settings, but certain
              features may not work correctly.
            </p>

            <h3>Intellectual Property</h3>
            <p>
              All content, features, and functionality of WafyNet (including
              text, images, software, trademarks, and design) are the property
              of WafyNet and protected by applicable copyright and
              intellectual property laws. Unauthorized use is strictly
              prohibited.
            </p>

            <h3>Termination</h3>
            <p>
              We may suspend or terminate your access to the Service at our
              discretion, without notice, if you violate these Terms. Upon
              termination, you must cease using the Service.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
              To the maximum extent permitted by law, WafyNet shall not
              be liable for any damages arising out of or related to your use of
              the Service. Your sole remedy is to discontinue using the Service.
            </p>

            <h3>Governing Law</h3>
            <p>
              These Terms shall be governed by and construed in accordance with
              the laws of India. Any disputes shall be subject to the exclusive
              jurisdiction of the courts in Tamil Nadu, India.
            </p>

            <h3>Changes to Terms</h3>
            <p>
              WafyNet reserves the right to update or modify these Terms &amp;
              Conditions at any time. Continued use of the Service after such
              changes constitutes your acceptance of the new Terms.
            </p>

            <h3>Contact Us</h3>
            <p>
              If you have questions about these Terms &amp; Conditions, please
              contact us:
            </p>
            <ul>
              <li>
                Email:{' '}
                <a href="mailto:support@wafynet.com">support@wafynet.com</a>
              </li>
              <li>
                Website:{' '}
                <a
                  href="https://www.wafynet.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.wafynet.com
                </a>
              </li>
            </ul>
          </div>
        </ShadowBox>
      </PrivacyWrapper>
    </>
  );
}
